import { gql } from 'apollo-boost';

export const createOrgUserMutation = gql`
  mutation createOrgUser($orgUser: OrgUserCreateInput!) {
    orgUser {
      create(orgUser: $orgUser) {
        id
        active
        firstName
        lastName
        roleId
        phone
        email
      }
    }
  }
`;

export const updateOrgUserMutation = gql`
  mutation updateOrgUser($orgUser: OrgUserUpdateInput!) {
    orgUser {
      update(orgUser: $orgUser) {
        id
        roleId
      }
    }
  }
`;

export const deleteItems = gql`
  mutation deleteOrgUserMutation($orgUserId: Int!) {
    orgUser {
      delete(orgUserId: $orgUserId)
    }
  }
`;
